<template>
  <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <div class="banner perBan">
      <img :src="banners.image" alt="">
      <div class="w1440">
        <div class="txt">
          <p class="fnt_52">
            {{ globalDataArray.siteTemplateLanguage.banner_welcome }}
            <template v-if="saitiAccessInfo.username!=''&&saitiAccessInfo.username!=null">
              {{ saitiAccessInfo.username }}
            </template>
            <template v-else-if="saitiAccessInfo.nickname!=''&&saitiAccessInfo.nickname!=null">
              {{ saitiAccessInfo.nickname }}
            </template>
          </p>
          <span class="fnt_18 mail" v-if="saitiAccessInfo.email!=''&&saitiAccessInfo.email!=null">
            {{ saitiAccessInfo.email }}
          </span>
          <span class="fnt_18" v-else-if="saitiAccessInfo.phone!=''&&saitiAccessInfo.phone!=null">
            {{ saitiAccessInfo.phone }}
          </span>
        </div>
      </div>
    </div>

    <div class="personPage">
      <div class="cf w1440">
        <div class="personLeft">
          <personmenu />
        </div>

        <div class="personRight right">
          <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.person_collect_record || '我的收藏' }}</div>
          <div class="no-data" v-if="competition.length <= 0">
            <img class="no-data-img" src="@/assets/images/no_data.png"></img>
          </div>
          <div class="browse-list ml12 mr12">
            <multi-condtion-info-new
              v-for="comp in competition"
              :key="comp.id"
              :show-object="comp"
              :from-query="fromQuery"
              @toSignFun="goDetail(comp)"
              @addBrowserAndBookmark="addBrowserAndBookmark"
            />
          </div>
          <div v-if="total > 0" class="p_page">
            <a-pagination
              v-model="current"
              :total="total"
              :page-size="pageSize"
              @change="handlePageChange"
              hide-on-single-page
              show-less-items
            />
          </div>
          <!--          <div class="problem_minebottom">
            <div class="problem-list">
              <div class="tabulation" v-for="(item, index) in list" :key="'collection' + index">
                <div class="tabulation_left" ref="imgDiv">
                  <router-link target="_blank" :to="'/competitionInfo?id=' + item.id">
                    <img :src="item.image" :style="{ height: imgheight + 'px' }" alt="">
                  </router-link>
                </div>
                <div class="tabulation_right" :class="item.signup == '04' ? 'endedPad' : ''">
                  <div class="right_box">
                    <div class="box_tit1 fnt_24" :title="item.title" :class="item.signup == '04' ? 'pr_30' : ''">
                      <router-link target="_blank" class="item" :to="'/competitionInfo?id=' + item.id">
                        {{ item.title }}
                      </router-link>
                    </div>
                    <div class="box_tit2" :class="item.signup == '04' ? 'pr_30' : ''">
                      <p class="fnt_16" v-for="(val, index1) in item.mark" :key="'val' + index1">
                        <span :title="val">{{ val }}</span>
                      </p>
                    </div>
                    <div class="box_tit3 fnt_14" :title="item.introduction">{{ item.introduction }}</div>
                    <div class="box_tit4">
                      <ul class="box_tit4ul">
                        <li v-if="item.bonus != '' && item.bonus != null">
                          <p class="fnt_22">{{ item.bonus }}</p>
                          <span class="fnt_14">{{ globalDataArray.siteTemplateLanguage.competition_bonus }}</span>
                        </li>
                        <li>
                          <p class="fnt_22">{{ item.teams > 999 ? '999+' : item.teams || 0 }}</p>
                          <span class="fnt_14">{{ globalDataArray.siteTemplateLanguage.competition_teams }}</span>
                        </li>
                        <li v-if="item.type_dictText">
                          <p class="fnt_22">{{ item.type_dictText }}</p>
                          <span class="fnt_14">{{ globalDataArray.siteTemplateLanguage.competition_type }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="box_tit5">
                      <div class="box_tit5_left">
                        {{ globalDataArray.siteTemplateLanguage.competition_co_builder }}:
                        <template v-if="item.organizersLogo">
                          <span class="img" v-for="(val, index1) in item.organizersLogo" :key="'organizersLogo' + index1">
                            <img :src="val" alt="">
                          </span>
                        </template>
                        <template v-else>
                          <span class="txt" v-if="item.organizers" :title="item.organizers[0]">{{ item.organizers[0] }}</span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="total > 0" class="p_page">
              <a-pagination
                v-model="current"
                :total="total"
                :page-size="pageSize"
                @change="handlePageChange"
                hide-on-single-page
                show-less-items
              />
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrowserAndBookmark } from '@/api/person/person.js'
import { getAdList } from '@/api/api'
import Cookies from 'js-cookie'
import MultiCondtionInfoNew from '@/views/saiti/components/MultiCondtionInfoNew.vue'
import { stringToDateTime } from '@/utils/util'
import { addBookmark } from '@/api/saiti'

export default {
  name: 'MyCollect',
  components: { MultiCondtionInfoNew },
  data() {
    return {
      title: this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteInfo.description,
      keywords: this.globalDataArray.siteInfo.keywords,
      saitiAccessInfo: '',
      competition: [],
      banners: {},
      page: 1,
      pageSize: 10,
      current: 1,
      total: 0,
      imgwidhth: 0,
      swiperOption: {
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      fromQuery: ''
    }
  },
  computed: {
    imgheight() {
      return Math.floor(this.imgwidhth * 0.65)
    }
  },
  mounted() {
    this.init()
    if (typeof window !== 'undefined') {
      window.onresize = () => {
        this.$nextTick(() => {
          if (this.$refs.imgDiv && this.$refs.imgDiv.length > 0) {
            this.imgwidhth = this.$refs.imgDiv[0].offsetWidth
          }
        })
      }
    }
  },
  methods: {
    init() {
      this.getAdList()
      this.getList()
      if (Cookies.get('saiti_access_info')) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
      }
    },
    getList() {
      const params = `page=${this.current}&pageSize=${this.pageSize}&recordType=2`
      getBrowserAndBookmark(params).then(res => {
        if (res.success) {
          /*          this.list = res.result.records.map(item => {
            return {
              ...item,
              mark: item.mark ? item.mark.split(',') : [],
              organizersLogo: item.organizersLogo ? item.organizersLogo.split(',') : [],
              organizers: item.organizers ? item.organizers.split(',') : [],
              parentId: item.parentId || item.id
            }
          })*/

          this.competition = res.result.records
          for (var i in this.competition) {
            if (this.competition[i].mark) {
              const mark = this.competition[i].mark
              this.competition[i].mark = mark.split(',')
            }

            if (this.competition[i].organizersLogo) {
              const organizersLogo = this.competition[i].organizersLogo
              this.competition[i].organizersLogo = organizersLogo.split(',')
            }

            if (this.competition[i].organizers) {
              const organizers = this.competition[i].organizers
              this.competition[i].organizers = organizers.split(',')
            }

            // 将utc时间转为当地时间并作比较
            const endUtcTime = this.competition[i].endUtcTime
            const localEndtimeStr = new Date(endUtcTime).getTime()
            this.competition[i]['localEndtime'] = stringToDateTime(localEndtimeStr)
            this.competition[i]['localEndtimeStr'] = localEndtimeStr
            if (this.competition[i].ccompetitions?.length > 0) {
              this.competition[i].ccompetitions.forEach(res => {
                res.localEndtimeStr = new Date(res.endUtcTime).getTime()
                if (typeof res.mark === 'string') {
                  res.mark = res.mark.split(',')
                }
                if (typeof res.organizersLogo === 'string') {
                  res.organizersLogo = res.organizersLogo.split(',')
                }
              })
            }
          }
          this.total = res.result.total
          this.$nextTick(() => {
            if (this.$refs.imgDiv && this.$refs.imgDiv.length > 0) {
              this.imgwidhth = this.$refs.imgDiv[0].offsetWidth
            }
          })
        }
      })
    },
    getAdList() {
      getAdList('alias=person_banner').then(res => {
        if (res.success) {
          this.banners = res.result[0]
        }
      })
    },
    goDetail(item) {
      this.$router.push({
        path: '/competitionInfo',
        query: { id: item.id }
      })
    },
    handlePageChange(page) {
      this.current = page
      this.getList()
    },
    toSignFun() {
      console.log('toSignFun')
    },
    addBrowserAndBookmark(params, showObject) {
      const newObj = 'type=' + params.type + '&parentcompetitionId=' + params.parentcompetitionld + '&competitionId=' + params.competitionld
      addBookmark(newObj).then(res => {
        if (res.success) {
          if (params.type === '3') {
            this.$message.success(this.globalDataArray.siteTemplateLanguage.unsubscribed_successfully)
          } else {
            this.$message.success(this.globalDataArray.siteTemplateLanguage.collection_successful)
          }
          this.getList()
        }
      })
    }
  }
}
</script>

<style scoped>
.problem-list {
  width: 100%;
  min-height: 200px;
}
</style>

<style scoped>
@import '@/assets/css/person.css';
@import '@/assets/css/problem.css';

.browse-list {
  margin: 24px 12px;
}

.no-data{
  background-color: #fff;
  width: 100%;
  text-align: center;
}

.no-data-img {
  width: 140px;
  margin: 20px 60px auto;
}
</style>
